import { get } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FlowItemForm } from '../../../shared/model/flow.types';
import { BeaconWeldingData } from '../model/beacon-welding-data';

export type ParameterMessageRule = {
  condition: (form: FlowItemForm) => boolean;
  translationKey: string;
  parameters: BeaconWeldingData.FlowItemParameterRef[];
  subtitleColor?: string;
  loading?: boolean;
};

const ALL_MESSAGE_RULES: ParameterMessageRule[] = [
  {
    condition: (form: FlowItemForm) => {
      const weaveEnabled = form.parameters?.weaveEnabled?.value ?? false;
      const weavePattern =
        form.parameters?.weavePattern?.value ??
        BeaconWeldingData.WeavePatternEnum.TRIANGLE;
      return (
        weaveEnabled &&
        weavePattern === BeaconWeldingData.WeavePatternEnum.WHIP_STITCH
      );
    },
    subtitleColor: 'warning',
    translationKey: 'welding:dwell_time_whip_stitch_warning',
    parameters: [
      BeaconWeldingData.FlowItemParameterRef.WEAVE_DWELL_TIME_1,
      BeaconWeldingData.FlowItemParameterRef.WEAVE_DWELL_TIME_2,
    ],
  },
];

export const useWeldParameterMessages = (
  form: FlowItemForm,
  formikValuePath?: string
) => {
  const { t } = useTranslation();

  return useMemo(() => {
    const actualForm: FlowItemForm = formikValuePath
      ? get(form, formikValuePath)
      : form;

    const messageInfo: Record<
      string,
      { subtext?: string; subtitleColor?: string; loading?: boolean }
    > = {};

    ALL_MESSAGE_RULES.forEach((rule) => {
      if (rule.condition(actualForm)) {
        const messageText = t(rule.translationKey);

        rule.parameters.forEach((paramRef) => {
          messageInfo[paramRef] = {
            subtext: messageText,
            subtitleColor: rule.subtitleColor || 'primary',
            loading: rule.loading,
          };
        });
      }
    });

    return messageInfo;
  }, [form, formikValuePath, t]);
};
